<template>
  <div class="row"><h3>Тайлангаа сонгоно уу</h3></div>
</template>
<script>
export default {
  name: 'starter-page',
  data() {
    return {};
  }
};
</script>
<style></style>